import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddEmployeeLayer from "../../../components/Admin/AddEmployeeLayer";

const AddEmployee = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddEmployeeLayer />
      </MasterLayout>
    </>
  );
};

export default AddEmployee;
